import { InjectionToken } from '@angular/core';

const EffyExperienceYears = new Date().getFullYear() - 2009;

/**
 * Replace accents from a string.
 *
 * @param str string
 * @returns string
 */
function stringToNormalForm(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function slugify(text) {
    return (text
        // Normalize the string in case there is french accents.
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace('-', '_')
        // Remove all punctuations from converted string.
        .replace(/[.,#!$%^&*;:{}=`~()"']/g, ''));
}

class NgxMaskUtil {
    static { this.phoneMask = '09 99 99 99 99'; }
    static { this.phonePatterns = { '0': { pattern: new RegExp('[0]') }, '9': { pattern: new RegExp('[0-9]') } }; }
    static { this.ibanMask = 'SS00 0000 0000 00AA AAAA AAAA A00'; }
}

const WINDOW = new InjectionToken('An abstraction over global window object', { factory: () => window });

/**
 * Generated bundle index. Do not edit.
 */

export { EffyExperienceYears, NgxMaskUtil, WINDOW, slugify, stringToNormalForm };
